import { useTranslation } from 'react-i18next';
import ModalFrame from '../../../ui/primitives/ModalFrame';
import { getFurnitureThumbPath, getFurnitureName, FURNITURE_CATEGORY_NAMES } from '../../../data/furniture';
import type { RenderFurniture } from '../../../domain/types';

interface CityHallFurnitureInfoModalProps {
  furniture: RenderFurniture;
  onClose: () => void;
}

/** City Hall furniture info modal (single-click for visitors). */
export default function CityHallFurnitureInfoModal({ furniture, onClose }: CityHallFurnitureInfoModalProps) {
  const { t } = useTranslation();

  return (
    <ModalFrame
      isOpen={true}
      onClose={onClose}
      variant="dialog"
      className="max-w-[400px]"
    >
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '20px' }}>
        <img
          src={getFurnitureThumbPath(furniture.furniture_catalog)}
          alt={getFurnitureName(furniture.furniture_catalog.id, t)}
          style={{ width: 'auto', height: 'auto', maxWidth: '80%', maxHeight: '240px', objectFit: 'contain', borderRadius: '12px' }}
        />
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', textAlign: 'center' }}>
          <div style={{ fontSize: '18px', fontWeight: 600, color: '#fff' }}>
            {getFurnitureName(furniture.furniture_catalog.id, t)}
          </div>
          {furniture.furniture_catalog.category && (
            <div style={{ fontSize: '13px', color: '#8899BB', fontWeight: 500 }}>
              {FURNITURE_CATEGORY_NAMES(t)[furniture.furniture_catalog.category as keyof ReturnType<typeof FURNITURE_CATEGORY_NAMES>] ?? furniture.furniture_catalog.category}
            </div>
          )}
          {furniture.purchased_by_name && (
            <div style={{ fontSize: '13px', color: '#8899BB', marginTop: '4px' }}>
              {t("Purchased by mayor")}: <span style={{ color: '#ef9b03', fontWeight: 600 }}>{furniture.purchased_by_name}</span>
            </div>
          )}
          {furniture.purchased_at && (
            <div style={{ fontSize: '12px', color: '#667799' }}>
              {new Date(furniture.purchased_at).toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' })}
            </div>
          )}
        </div>
      </div>
    </ModalFrame>
  );
}
